import {inject, Injectable} from '@angular/core';
import {AppStore} from '../store/app.store';

type AccessKeys = {
  send_quote_via_text?: boolean;
  send_quote_via_email?: boolean;
  send_quote_via_print?: boolean;
  edit_settings?: boolean;
  view_item_history?: boolean;
  edit_item?: boolean;
  view_spiff_codes?: boolean;
  view_rebates?: boolean;
  change_results_price_level?: boolean;
  connect_new_vendor?: boolean;
  save_for_later?: boolean;

  add_to_quote?: boolean;
  create_quote?: boolean;
  create_transfer?: boolean;
  submit_transfer?: boolean;
  create_purchase_order?: boolean;
  submit_purchase_order?: boolean;
  quick_add?: boolean;
};

export type AccessKey = keyof AccessKeys;

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  private store = inject(AppStore);

  can = (key: AccessKey | AccessKey[]): boolean => {
    const keys = Array.isArray(key) ? key : [key];
    return keys.every((k) => this.store.permissions()[k] ?? true);
  };

  cannot = (key: AccessKey | AccessKey[]): boolean => !this.can(key);

  has = (key: AccessKey | AccessKey[]): boolean => {
    const keys = Array.isArray(key) ? key : [key];
    return keys.every((k) => this.store.capabilities()[k] ?? true);
  };

  lacks = (key: AccessKey | AccessKey[]): boolean => !this.has(key);

  getTitle = (key: AccessKey | AccessKey[], fallback: string = '', title: string = ''): string => {
    const keys = Array.isArray(key) ? key : [key];
    const denied = keys.filter((k) => this.cannot(k)).map((k) => k.replaceAll('_', ' '));
    if (!denied.length) return fallback;
    return title || `You do not have permission to ${denied.join(' or ')}`;
  };
}
